import { Phone, MessageSquare, Mail, Clock } from "lucide-react";
import { Reveal } from "../lib/motion";
import { links } from "../lib/contact";
import { PinMark } from "./PinMark";

// WhatsApp glyph (lucide has no brand icon)
const WhatsApp = ({ size = 22, className = "" }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
  </svg>
);

const ACTIONS = [
  { icon: Phone, label: "Call Recovery Rides", href: links.call, testId: "req-call" },
  { icon: MessageSquare, label: "Send a Text", href: links.text, testId: "req-text" },
  { icon: WhatsApp, label: "Message on WhatsApp", href: links.whatsapp, testId: "req-whatsapp" },
  { icon: Mail, label: "Email About Services", href: links.serviceMail, testId: "req-email" },
];

export const RequestService = () => (
  <section id="contact" className="relative bg-white py-20 sm:py-28">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
      <Reveal>
        <div className="inline-flex items-center justify-center h-14 w-14 mb-6">
          <PinMark id="reqPin" className="h-14 w-14" />
        </div>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#3B3A4E] leading-tight">
          Need Recovery Rides Services?
        </h2>
      </Reveal>
      <Reveal delay={0.08}>
        <p className="mt-5 text-base sm:text-lg text-[#5C5975] leading-relaxed max-w-2xl mx-auto">
          Whether you need immediate transportation, want to schedule a future ride, or need concierge support
          for your facility or residence, contact Recovery Rides by phone, text, WhatsApp, or email.
        </p>
      </Reveal>

      <Reveal delay={0.14}>
        <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {ACTIONS.map((a) => (
            <a
              key={a.label}
              href={a.href}
              className="group flex items-center gap-4 rounded-2xl bg-[#FAFAF9] border border-[#3B3A4E]/8 p-5 text-left transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-[#00B4B4]/30 focus:outline-none focus:ring-4 focus:ring-teal-200"
              data-testid={a.testId}
            >
              <span className="h-12 w-12 shrink-0 rounded-xl brand-gradient flex items-center justify-center text-white shadow-md shadow-teal-500/20 group-hover:scale-105 transition-transform">
                <a.icon size={22} />
              </span>
              <span className="font-heading font-semibold text-[#2D2B3D]">{a.label}</span>
            </a>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-8 inline-flex items-center gap-2 text-sm text-[#5C5975]">
          <Clock size={15} className="text-[#0891B2]" />
          Available 24/7 depending on driver availability.
        </p>
      </Reveal>
    </div>
  </section>
);
